<template>
  <ReportsComponent
    :urls="urls"
    :mandatory-filter="[
      {
        name: 'date_range',
        title: 'Date range',
        valueFieldName: '.date',
      },
    ]"
  />
</template>

<script>
import ReportsComponent from "@/own/components/reports/ReportComponent";

export default {
  name: "ClientsMovements",
  components: {
    ReportsComponent,
  },
  computed: {
    urls: () => ({
      data_url: "/reports/reportClientsMovements",
      show_url: "/reports/reportClientsMovements/show",
    }),
  },
};
</script>
